// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function SponsorshipRow() {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['Sponsorship']

   if (state.product_list['sponsorship']?.NotInPricebook) {
      return <> </>
   }

   if (permissions.includes(state.user_role) || state.productSponsorship)
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {state.product_list['sponsorship']['ProductName']}
            </div>
            <div className='col-bhr2'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.productSponsorship}
                  onChange={() => state.setProductSponsorship((prev) => !prev)}
               ></input>
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.SponsorshipCosts.totalPrice,
                  state.currencyObject,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )

   return null
}
